import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DatePicker, TimePicker } from 'antd';
import dayjs from 'dayjs'; // ✅ use dayjs instead of moment

const ErrorModal = ({ error, isVisible, setIsVisible, seterror }) => {
  function normalizeError(error) {
    try {
      const parsed = JSON.parse(error);
      if (Array.isArray(parsed)) {
        return parsed; // return as array if it's a stringified array
      }
    } catch (e) {
      // not JSON → just return as string
    }
    return [error]; // wrap string in an array for consistency
  }
  return (
    <div>
      {isVisible && (
        <Modal show={isVisible} onHide={() => setIsVisible(false)} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
              <label>Collection Date :</label>
              <DatePicker format='YYYY-MM-DD' value={date} onChange={handleDateChange} allowClear style={{ width: '50%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
              <label>Collection Time :</label>
              <TimePicker format='HH:mm:ss' value={time} onChange={handleTimeChange} allowClear style={{ width: '50%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
            </div> */}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
              {/* Date */}
              {normalizeError(error).map((err, index) => (
                <div key={index}>{err}</div>
              ))}

              {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>{normalizeError(error).join("\n")}</div> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className='col-lg-2 btn-style'
              variant='secondary'
              onClick={() => {
                setIsVisible(false);
                seterror('');
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ErrorModal;
